// Core
import { useState, useEffect, useRef } from 'react';
import { MdInfoOutline } from "react-icons/md";
import { FaOilCan } from "react-icons/fa";
import { FaSitemap } from "react-icons/fa";
import { MdDoubleArrow } from 'react-icons/md';
import { FaHandshake } from "react-icons/fa6";
import { HiEmojiHappy } from "react-icons/hi";
import { MdToken } from 'react-icons/md';
import { FaWifi } from "react-icons/fa";

// Chakra 
import { 
  Box,
  Button,
  Divider,
  Image,
  Flex, 
  Grid,
  FormControl,
  FormLabel,
  FormHelperText,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Spinner,
  Text, 
  useColorModeValue,
  useDisclosure
} from '@chakra-ui/react';

const ProgressModal = ({ 
  isOpen, onOpen, onClose
}) => {

  const handleNewGame = () => {
    localStorage.clear(); 
    window.location.reload();  
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose}>
      <ModalOverlay />
      <ModalContent className="modal__simple modal__progress" maxW={{ sm: '100%', zIndex: '99999' }}>
        <ModalBody>
          <Text>Begin a new journey! All progress will be reset, and your tokens will be restored to default.</Text>
          <Box mt="24px">
            <Button 
              variant="solid-md"
              maxW="100%"
              w="100%"
              onClick={handleNewGame}>New game</Button>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal> 
  );
};

export default ProgressModal;